import React from "react";
import { inject, observer } from "mobx-react";

import QuestionEdit from "./question-edit";
import QuestionList from "./question-list";

const QuestionContainer = ({ store, mode }) => {
  const { $question } = store;

  return (
    <React.Fragment>
      {(mode === "edit" || mode === "new" || $question.selected) && (
        <QuestionEdit />
      )}
      {(!mode || mode === "view") && (
        <QuestionList activeQuestion={$question.activeQuestion} mode={mode} />
      )}
    </React.Fragment>
  );
};

export default inject("store")(observer(QuestionContainer));
